import { createQuickNotesState, type QuickNotesState } from "../features/quick-notes/state.ts";
import { createTaskPanelState, type TaskPanelState } from "../features/tasks/panel-state.ts";
import { ApiClient, apiClient } from "../infrastructure/api/client.ts";

export interface AppState {
  taskPanel: TaskPanelState;
  quickNotes: QuickNotesState;
}

export interface AppServices {
  api: ApiClient;
}

export interface AppContext {
  state: AppState;
  services: AppServices;
}

export function createAppContext(api: ApiClient = apiClient): AppContext {
  return {
    state: {
      taskPanel: createTaskPanelState(),
      quickNotes: createQuickNotesState(),
    },
    services: { api },
  };
}
